import React from 'react';

import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from '../../services/helpers.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import store from '../../redux/store.js';

/**
 *
 * @param {*} props
 */
export default function Efap({ classes, expanded, efap, handleChange, theme }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('efap')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('efap') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles["employee assistance program"])}</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                {
                    efap.isEligible === 1 ?
                        <React.Fragment>
                            {
                                efap.carrier.toUpperCase() === 'HUMANACARE' ?
                                    <div style={classes.row}>
                                        <Text small bold margin="20px 0px 10px 0px">
                                            { i18n.t(tokens.labels.coverage.employeeAssistanceProgramHumanacare) }
                                        </Text>
                                    </div>
                                :
                                null
                            }
                            
                            {
                                efap.carrier.toUpperCase() === 'DIALOGUE' ?
                                    <div style={classes.row}>
                                        <Text small bold margin="20px 0px 10px 0px">
                                            { i18n.t(tokens.labels.coverage.employeeAssistanceProgramDialogue) }
                                        </Text>
                                    </div>
                                    :
                                    null
                            }

                            <div>
                                {
                                    efap.includeOutOfCountryMedicalReferral ?
                                        <React.Fragment>
                                            <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.outOfCountryMedicalReferralMax, { outOfCountryMedicalReferralMax: numberWithCommas(efap.outOfCountryMedicalReferralMax) }) } </Text>
                                            <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.outOfCountryMedicalReferralPerYearReimbursement, { outOfCountryMedicalReferralPerYearReimbursement: efap.outOfCountryMedicalReferralPerYearReimbursement })} </Text>
                                        </React.Fragment>
                                        : 
                                        null
                                }

                                {
                                    efap.includeEldercare ?
                                        <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.eldercareBenefitsIncluded) }</Text>
                                        : 
                                        null
                                }

                                {
                                    efap.includeMedicalSecondOpinion ?
                                        <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.medicalSecondOpinionBenefitsIncluded) }</Text>
                                        : 
                                        null
                                }
                            </div>

                            {
                                efap.carrier.toUpperCase() === 'HUMANACARE' &&
                                    <div>
                                        <a href="https://d6hvupc5g7lnm.cloudfront.net/files/EFAP_Guide.pdf" download="EFAP Guide.pdf" style={{ textDecoration: 'none', marginTop: 10 }} target="_blank"
                                            rel="noopener noreferrer">
                                            <Text
                                                color={store.getState().whitelabel.secondaryColor || theme.colors.skyBlue}
                                                small
                                                display="block"
                                            >
                                                { i18n.t(tokens.labels.coverage.efapGuide) }
                                            </Text>
                                        </a>

                                        <a href="https://humanacare.com/simplybenefits" style={{ textDecoration: 'none'}} target="_blank"
                                            rel="noopener noreferrer">
                                            <Text
                                                color={store.getState().whitelabel.secondaryColor || theme.colors.skyBlue}
                                                small
                                                display="block"
                                            >
                                                { i18n.t(tokens.labels.coverage.learnMoreAboutEfap) }
                                            </Text>
                                        </a>

                                        <a href="tel:1-800-661-8193" style={{ textDecoration: 'none'}} target="_blank"
                                            rel="noopener noreferrer">
                                            <Text
                                                color={store.getState().whitelabel.secondaryColor || theme.colors.skyBlue}
                                                small
                                                bold
                                            >
                                                { i18n.t(tokens.labels.coverage.callHumanacare) }
                                            </Text>
                                        </a>
                                    </div>
                            }

                            {
                                efap.carrier.toUpperCase() === 'DIALOGUE' &&
                                    <div>
                                        <Text small bold margin="15px 0px 10px 0px">
                                            { i18n.t(tokens.labels.coverage.dialogueEfapAccess) }
                                        </Text>

                                        <ul style={{ listStyle: 'disc', paddingLeft: '16px', marginLeft: '1px' }}>
                                            <li><Text small margin="0px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.mentalHealthServices) }</Text></li>
                                            <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.familyAndRelationships) }</Text></li>
                                            <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.workAndCareer) }</Text></li>
                                            <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.legalServices) }</Text></li>
                                            <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.financialServices) }</Text></li>
                                        </ul>

                                        <Text small margin="10px 0px 0px 0px">
                                            <a href="https://pages-support.dialogue.co/eap-signup/" target="_blank" rel="noopener noreferrer">{ i18n.t(tokens.labels.coverage.learnMoreAboutEfap) }</a>
                                        </Text>
                                    </div>
                            }   
                            
                        </React.Fragment>
                        :
                        <div style={classes.row}>
                            <Text small bold margin="20px 0px 10px 0px">
                                { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                            </Text>
                        </div>
                }
                </AccordionDetails>
            </Accordion>
        </div>
    )
}